const KEY = 'NixlocKey'

function xor(texto) {
  let result = ''
  for (let i = 0; i < texto.length; i++) {
    result += String.fromCharCode(texto.charCodeAt(i) ^ KEY.charCodeAt(i % KEY.length))
  }
  return result
}

export function embaralhar(texto) {
  return btoa(xor(texto))
}

export function desembaralhar(texto) {
  return xor(atob(texto))
}
